(function () {
  var storageKey = 'second-cuties-favorites-v1';
  var teddyIconUrl = 'https://cdn.shopify.com/s/files/1/1063/3766/5354/files/second-cuties-teddy-heart-icon-v1.png?v=1787730965';

  function getFavorites() {
    try {
      var favorites = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(favorites) ? favorites : [];
    } catch (error) {
      return [];
    }
  }

  function setFavorites(favorites) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(favorites));
    } catch (error) {
      return;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
    });
  }

  function productFromButton(button) {
    return {
      id: String(button.dataset.favoriteId || button.dataset.favoriteHandle || ''),
      handle: button.dataset.favoriteHandle || '',
      title: button.dataset.favoriteTitle || '',
      url: button.dataset.favoriteUrl || '',
      image: button.dataset.favoriteImage || ''
    };
  }

  function isFavorite(productId) {
    return getFavorites().some(function (item) {
      return item.id === String(productId);
    });
  }

  function updateButton(button) {
    var active = isFavorite(button.dataset.favoriteId || button.dataset.favoriteHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen');
    var label = button.querySelector('.visually-hidden');
    if (label) label.textContent = active ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen';
  }

  function updateCount() {
    var count = getFavorites().length;
    document.querySelectorAll('[data-favorites-count]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  function renderFavoritesPage() {
    var list = document.querySelector('[data-favorites-list]');
    if (!list) return;

    var favorites = getFavorites();
    if (!favorites.length) {
      list.innerHTML = '<div class="second-cuties-favorites__empty"><p>Noch keine Favoriten gespeichert.</p><a class="button button--secondary" href="/collections/all">Lieblingsstücke entdecken</a></div>';
      return;
    }

    list.innerHTML = favorites.map(function (item) {
      var image = item.image
        ? '<a class="second-cuties-favorites__image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt=""></a>'
        : '';
      return '<article class="second-cuties-favorites__card">' +
        image +
        '<button type="button" class="second-cuties-favorite-button second-cuties-favorites__remove is-active" data-favorite-product data-favorite-id="' + escapeHtml(item.id) + '" data-favorite-handle="' + escapeHtml(item.handle) + '" data-favorite-title="' + escapeHtml(item.title) + '" data-favorite-url="' + escapeHtml(item.url) + '" data-favorite-image="' + escapeHtml(item.image) + '" aria-pressed="true" aria-label="Aus Favoriten entfernen"><img class="second-cuties-favorite-symbol" src="' + teddyIconUrl + '" alt="" width="48" height="59" loading="lazy"><span class="visually-hidden">Aus Favoriten entfernen</span></button>' +
        '<div class="second-cuties-favorites__content"><a class="second-cuties-favorites__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></div>' +
      '</article>';
    }).join('');
  }

  function refresh() {
    document.querySelectorAll('[data-favorite-product]').forEach(updateButton);
    updateCount();
    renderFavoritesPage();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-favorite-product]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var product = productFromButton(button);
    if (!product.id) return;

    var favorites = getFavorites();
    var index = favorites.findIndex(function (item) {
      return item.id === product.id;
    });

    if (index === -1) {
      favorites.unshift(product);
    } else {
      favorites.splice(index, 1);
    }

    setFavorites(favorites);
    refresh();
  });

  window.addEventListener('storage', refresh);
  document.addEventListener('shopify:section:load', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
